import { Trophy } from "lucide-react";

const LEVELS = [
  { level: 1, name: "Newcomer", min: 0 },
  { level: 2, name: "Explorer", min: 50 },
  { level: 3, name: "Regular", min: 150 },
  { level: 4, name: "Veteran", min: 300 },
  { level: 5, name: "Legend", min: 500 },
];

// Big, warm hero for the House Points tab: your level, points, progress and the ladder to Legend.
export default function LevelHero({ passport }) {
  const { level, total_points, total_badges } = passport;
  const next = LEVELS.find((l) => l.level === level.level + 1);
  const pct = Math.max(4, Math.min(100, Math.round(level.progress_to_next || 0)));

  return (
    <div className="rounded-2xl p-5 bg-[#2E2A26] text-white shadow-lg shadow-stone-300/40 relative overflow-hidden" data-testid="points-hero">
      <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-[#C85A38]/30 blur-2xl pointer-events-none" aria-hidden="true" />
      <div className="relative flex items-start gap-4">
        <div className="w-14 h-14 rounded-2xl bg-[#C85A38] flex items-center justify-center flex-shrink-0 shadow-md">
          <Trophy className="w-7 h-7 text-white" strokeWidth={1.8} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/55">House Points</p>
          <h2 className="font-serif text-2xl leading-tight mt-0.5" data-testid="points-hero-level">
            Level {level.level} · {level.name}
          </h2>
          <p className="text-sm text-white/70 mt-1" data-testid="points-hero-total">
            <span className="text-white font-semibold">{total_points} pts</span> · {total_badges} {total_badges === 1 ? "badge" : "badges"}
            {next && <> · <span className="text-[#F2C8B4] font-medium">{level.points_to_next} to {next.name}</span></>}
          </p>
        </div>
      </div>

      <div className="relative mt-4 h-2.5 rounded-full bg-white/15 overflow-hidden" aria-hidden="true">
        <div className="h-full rounded-full bg-gradient-to-r from-[#C85A38] to-[#F2C8B4] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>

      <ol className="relative mt-3 grid grid-cols-5 gap-1" data-testid="points-level-ladder">
        {LEVELS.map((l) => {
          const reached = l.level <= level.level;
          const current = l.level === level.level;
          return (
            <li key={l.level} className="text-center min-w-0">
              <div className={`mx-auto w-2 h-2 rounded-full mb-1 ${current ? "bg-[#F2C8B4] ring-4 ring-[#C85A38]/40" : reached ? "bg-[#C85A38]" : "bg-white/25"}`} />
              <p className={`text-[10px] leading-tight truncate ${current ? "text-white font-semibold" : reached ? "text-white/80" : "text-white/40"}`}>{l.name}</p>
              <p className={`text-[9px] ${current ? "text-[#F2C8B4]" : "text-white/35"}`}>{l.min}</p>
            </li>
          );
        })}
      </ol>

      <div className="relative mt-4 grid grid-cols-3 gap-2 text-[11px]" data-testid="points-how-it-works">
        {[["1", "Do something good for the house"], ["2", "Tap the badge, tell Steve in one line"], ["3", "He says yes — points land, you level up"]].map(([n, text]) => (
          <div key={n} className="rounded-xl bg-white/8 border border-white/10 px-2.5 py-2">
            <span className="inline-flex w-5 h-5 rounded-full bg-[#C85A38] text-white items-center justify-center text-[10px] font-bold mb-1">{n}</span>
            <p className="text-white/80 leading-snug">{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
